import { OBJECTIVE_TYPES_MAP } from 'constants/ProjectConstants';

import { useEmployeeGoalsPrivileges } from './useEmployeeGoalsPrivileges';
import useOKRConfig from './useOKRConfig';

const useOKRInsightsPermissionsBasedOnEmployeeGoalsPrivileges = () => {
  const {
    hasViewIndividualInsightsPrivilege,
    hasDownloadIndividualInsightsPrivilege,
    // hasViewObjectiveInsightsPrivilege,
    hasDownloadObjectiveInsightsPrivilege,
  } = useEmployeeGoalsPrivileges();

  const { OBJECTIVE_TYPE } = useOKRConfig();

  // hardcoding it to true
  // REFER: https://peoplemesh.slack.com/archives/C068QAF71N0/p1714134053687199?thread_ts=1714117695.663899&cid=C068QAF71N0
  const hasViewObjectiveInsightsPrivilege = true;

  const isObjectiveDisabled = OBJECTIVE_TYPE === OBJECTIVE_TYPES_MAP.DISABLED.value;

  const canViewDownloadIndividualInsights =
    hasViewIndividualInsightsPrivilege || hasDownloadIndividualInsightsPrivilege;

  const canViewDownloadObjectiveInsights =
    !isObjectiveDisabled && (hasViewObjectiveInsightsPrivilege || hasDownloadObjectiveInsightsPrivilege);

  return {
    canViewDownloadIndividualInsights,
    canViewDownloadObjectiveInsights,
  };
};

export default useOKRInsightsPermissionsBasedOnEmployeeGoalsPrivileges;
